import type { RaterXPreset } from '../../../api/types/rater-x-preset';

/**
 * Whether the rater terminally declined this tower. A decline is signalled by
 * either an explicit flag (top-level or global) or the presence of declination
 * reasons — the rater can fast-decline with or without echoing pricing, so any
 * one of these is sufficient (FPX-5969).
 */
export function isRaterDeclined(response: RaterXPreset | null): boolean {
  if (response == null) {
    return false;
  }

  const hasReasons = (response.global?.declinationReasons?.length ?? 0) > 0;

  return response.declines === true || response.global?.declines === true || hasReasons;
}
